import { LegacyLoader } from 'src/components/Loader/LegacyLoader';

export default LegacyLoader;
